<swiper
	[direction]="'vertical'"
	[loop]="true"
	[autoHeight]="true"
	[allowTouchMove]="false"
	[autoplay]="{ delay: 1000, disableOnInteraction: false }"
	[pagination]="false"
	[navigation]="false"
>
	<ng-template data-swiper-autoplay="2500" swiperSlide>
		<div class="d-flex h-100">
			<h6 class="mb-0 f-w-400">
				<span class="f-light">{{ 'Your email is not verified.' | translate }}</span>
			</h6>
			<i class="icon-arrow-top-right f-light"></i>
		</div>
	</ng-template>
	<ng-template data-swiper-autoplay="5000" swiperSlide>
		<div class="d-flex h-100">
			<h6 class="mb-0 f-w-400">
				<span class="f-light">
					{{ 'Please Check your inbox and valid verification details .' | translate }}</span
				>
			</h6>
		</div>
	</ng-template>
</swiper>
